import React from 'react';
import { Box } from '@mui/material';

export interface FadeUpProps {
  key?: React.Key;
  children: React.ReactNode;
}

const FadeUp: React.FC<FadeUpProps> = ({ key, children }) => {
  return (
    <Box
      key={key}
      sx={{
        '@keyframes fadeUp': {
          from: {
            opacity: 0,
            transform: 'translateY(10px)',
          },
          to: {
            opacity: 1,
            transform: 'translateY(0)',
          },
        },
        animation: 'fadeUp 320ms cubic-bezier(0.33, 1, 0.68, 1) both',
      }}
    >
      {children}
    </Box>
  );
};

export default FadeUp;
